import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import commonEnUS from './locales/en_us/common.json'
import commonFrCA from './locales/fr_ca/common.json'
import NLLEnUs from './locales/en_us/NLL.json'
import NLLFrCA from './locales/fr_ca/NLL.json'
import IRSEnUs from './locales/en_us/IRS.json'
import IRSFrCA from './locales/fr_ca/IRS.json'
import GNSEnUs from './locales/en_us/GNS.json'
import GNSFrCA from './locales/fr_ca/GNS.json'

const vendorCode = 'common'
const vendorResources = {
  'common': {
    'en': {
      common: commonEnUS
    },
    'en-us': {
      common: commonEnUS
    },
    'fr': {
      common: commonFrCA
    },
    'fr-ca': {
      common: commonFrCA
    },
  },
  'NLL': {
    'en': {
      common: NLLEnUs
    },
    'en-us': {
      common: NLLEnUs
    },
    'fr': {
      common: NLLFrCA
    },
    'fr-ca': {
      common: NLLFrCA
    }
  },
  'IRS': {
    'en': {
      common: IRSEnUs
    },
    'en-us': {
      common: IRSEnUs
    },
    'fr': {
      common: IRSFrCA
    },
    'fr-ca': {
      common: IRSFrCA
    }
  },
  'GNS': {
    'en': {
      common: GNSEnUs
    },
    'en-us': {
      common: GNSEnUs
    },
    'fr': {
      common: GNSFrCA
    },
    'fr-ca': {
      common: GNSFrCA
    }
  }
}

const resources = vendorResources[vendorCode] || vendorResources['common']
const defaultLangDetector = new LanguageDetector(null, {
  // order and from where user language should be detected
  order: ['querystring', 'htmlTag', 'navigator'],
  // keys or params to lookup language from
  lookupQuerystring: 'lang',
  // Don't use the default (document.documentElement) because that can
  // trigger the browsers auto-translate, which is quite annoying.
  htmlTag: window.document ? window.document.head : undefined
})

i18next
  .use(initReactI18next)
  .use(defaultLangDetector)
  .init({
    resources,
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  })

export default i18next
